module.exports = __webpack_public_path__ + "static/media/PB_Y_03.6b9ec928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_03.png
// module id = 232
// module chunks = 0